import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Box, Grid, makeStyles } from '@applyboard/ui-components';
import ScoreInput from "../ScoreInput";
var initialError = {
  invalid: new Set()
};
var useStyles = makeStyles({
  content: {
    margin: '8px 0 23px 0'
  }
});
var ExamScores = function ExamScores(props) {
  var _value$total, _value$l, _value$r, _value$w, _value$s;
  var exam = props.exam,
    value = props.value,
    onChange = props.onChange,
    _props$error = props.error,
    error = _props$error === void 0 ? initialError : _props$error,
    showError = props.showError;
  var classes = useStyles();
  var total = (_value$total = value.total) !== null && _value$total !== void 0 ? _value$total : '';
  var l = (_value$l = value.l) !== null && _value$l !== void 0 ? _value$l : '';
  var r = (_value$r = value.r) !== null && _value$r !== void 0 ? _value$r : '';
  var w = (_value$w = value.w) !== null && _value$w !== void 0 ? _value$w : '';
  var s = (_value$s = value.s) !== null && _value$s !== void 0 ? _value$s : '';
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, exam === 'PTE' && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(ScoreInput, {
    exam: exam,
    label: "Total Score",
    name: "total",
    value: total,
    onChange: onChange,
    showError: showError,
    errorMessage: error.invalid.has('total') && error.message
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(ScoreInput, {
    exam: exam,
    label: "Listening",
    name: "l",
    value: l,
    onChange: onChange,
    showError: showError,
    errorMessage: error.invalid.has('l') && error.message
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(ScoreInput, {
    exam: exam,
    label: "Reading",
    name: "r",
    value: r,
    onChange: onChange,
    showError: showError,
    errorMessage: error.invalid.has('r') && error.message
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(ScoreInput, {
    exam: exam,
    label: "Writing",
    name: "w",
    value: w,
    onChange: onChange,
    showError: showError,
    errorMessage: error.invalid.has('w') && error.message
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(ScoreInput, {
    exam: exam,
    label: "Speaking",
    name: "s",
    value: s,
    onChange: onChange,
    showError: showError,
    errorMessage: error.invalid.has('s') && error.message
  })))));
};
export default ExamScores;